/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AutoTestStepBase } from './AutoTestStepBase';
import { AutoTestStepLogBase } from './AutoTestStepLogBase';
import { AutoTestStepResultState } from './AutoTestStepResultState';
import { CustomOutputLog } from './CustomOutputLog';
import { IOTestLog } from './IOTestLog';
import { JunitTestLog } from './JunitTestLog';
import { QualityTestLog } from './QualityTestLog';
import { RunProgramLog } from './RunProgramLog';
const AutoTestStepResultParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['autoTestStep', AutoTestStepBase, 'auto_test_step'],
    ['state', AutoTestStepResultState],
    ['achievedPoints', codecNumber, 'achieved_points'],
    [
        'log',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ parsers.lazy(() => 
        /* #__PURE__ */ codecOneOf([
            RunProgramLog,
            CustomOutputLog,
            JunitTestLog,
            QualityTestLog,
            IOTestLog,
            AutoTestStepLogBase,
        ]))),
    ],
    ['startedAt', /* #__PURE__ */ parsers.maybeNull(parsers.moment), 'started_at'],
    [
        'attachmentId',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'attachment_id',
    ],
]));
export class AutoTestStepResult extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestStepResultParser.decode(input).map(res => new AutoTestStepResult(res));
    }
    static unsafeDecode(input) {
        return AutoTestStepResult.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestStepResultParser.encode(data);
    }
    static schema() {
        return AutoTestStepResultParser.schema();
    }
}
